import * as React from 'react';
import {PureComponent, createElement, createRef, ReactNode, SyntheticEvent} from 'react';
import Point from "./icons/Pin";
import Polygon from "./icons/Polygon";
import Buffer from './icons/Buffer';
import Measure from './icons/Measure';
import Layers from './icons/Layers';
import Line from './icons/Line';
import Table from './icons/Datatable';

interface IProps {
    toggleLayers: (value: boolean) => void;
    toggleTable: (value: boolean) => void;
    toggleFeature: (isDrawing: boolean, type: string) => void;
    editMode: string;
    buffer: any;
    measure: any;
    isDrawing: boolean;
    isMeasuring: boolean;
    isEditingGeometry: boolean;
    showLayers: boolean;
    showTable: boolean;
    className: string;
}

const drawConfig = {
    point: 'point',
    polygon: 'polygon',
    line: 'line',
};

export default class DataControls extends PureComponent<IProps, any> {

    _containerRef = createRef();
    state = {
        isDrawing: false,
    }

    _renderButton = (type: string, label: string, callback: any, children: ReactNode) => {
        let activeClass;

        switch (type) {
            case 'Layers':
                activeClass = this.props.showLayers ? 'active' : '';
                break;
            case 'Table':
                activeClass = this.props.showTable ? 'active' : '';
                break;
            case 'Measure':
                activeClass = this.props.isMeasuring ? 'active' : '';
                break;
            default:
                activeClass = this.props.editMode ? this.props.editMode.toLowerCase() === type.toLowerCase() ? 'active' : '' : '';
        }

        return createElement('button', {
            key: type,
            className: `data-ctrl-icon data-ctrl-${type} ${activeClass}`,
            type: 'button',
            title: label,
            onClick: callback,
            children,
        });
    }

    handleDrawButtonClick = (type='Polygon') => (event: SyntheticEvent) => {
        this.stopEventPropagation(event);

        let isDrawing = true;
        if (type && type.toLowerCase() === this.props.editMode.toLowerCase()) {
            isDrawing = false;
        }

        this.setState({isDrawing});
        this.props.toggleFeature(isDrawing, type);
    };

    stopEventPropagation = (event: SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
    }

    handleBufferClick = (event: SyntheticEvent) => {
        this.stopEventPropagation(event);
        this.props.buffer();
    }

    handleMeasureClick = (event: SyntheticEvent) => {
        this.stopEventPropagation(event);
        this.props.measure();
    }

    handleLayersClick = (event: SyntheticEvent) => {
        this.stopEventPropagation(event);
        this.props.toggleLayers(!this.props.showLayers);
    }

    handleTableClick = (event: SyntheticEvent) => {
        this.stopEventPropagation(event);
        this.props.toggleTable(!this.props.showTable);
    }

    render () {
        const {className, isEditingGeometry} = this.props;
        const {isDrawing} = this.props || this.state;
        return createElement('div', {
            className: `data-ctrl data-ctrl-group ${className}`,
            ref: this._containerRef
        }, [
            this._renderButton('Layers', 'Layer list on/off', this.handleLayersClick,
                <Layers/>
            ),
            this._renderButton('Table', 'Contact Table', this.handleTableClick,
                <Table/>
            ),
            this._renderButton('Point', 'Point', this.handleDrawButtonClick(drawConfig.point),
                <Point/>
            ),
            // this._renderButton('Polygon', 'Polygon', this.handleDrawButtonClick(drawConfig.polygon),
            //     <Polygon/>
            // ),
            // this._renderButton('Line', 'Line', this.handleDrawButtonClick(drawConfig.line),
            //     <Line/>
            // ),
            // isDrawing && !isEditingGeometry && this._renderButton('Buffer', 'Buffer', this.handleBufferClick,
            //     <Buffer/>
            // ),
            // this._renderButton('Measure', 'Measure', this.handleMeasureClick,
            //     <Measure/>
            // ),
        ]);
    }
}
